(function () {
  function initHeader() {
    var header = document.querySelector('[data-sq-header]');
    if (!header) return;

    var toggle = header.querySelector('[data-sq-nav-toggle]');
    var drawerLinks = header.querySelectorAll('[data-sq-drawer] a');

    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    drawerLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initSmoothScroll() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', id);
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.sq-reveal');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initHero() {
    var hero = document.querySelector('[data-sq-hero]');
    if (!hero) return;
    requestAnimationFrame(function () {
      hero.classList.add('is-ready');
    });
  }

  function boot() {
    initHeader();
    initSmoothScroll();
    initReveal();
    initHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
